<app-list-table-filters-wrapper
  [title]="'Appeals' | translate"
  [parentRoute]="'/admin'"
  [subtitle]="'View and analyze system security events' | translate"
  [columns]="tableColumns"
  [service]="service"
  [getAllMethod]="getAllMethod"
  [getTotalMethod]="getTotalMethod"
  [(filterModel)]="filterModel"
  [filtersForms]="filtersForms"
  (applyFilters)="applyFilters()"
  (clearFilters)="clearFilters()"
  [isLoading]="loading"
  [storageKey]="storageKey"
  [toggleFilter]="toggleFilter"
  [defaultParams]="defaultParams"
  (onRowClick)="goToChat($event)"
  [filtersParams]="filtersParams">



  <ng-template #createAt let-row>
    {{ row.createAt | dateFormatLang:tr.currentLang:true }}
  </ng-template>
  
  <ng-template #moduleNameTemplate let-row>
    {{ getLocalizedModuleNameByName(row.moduleName) }}
  </ng-template>
  
  <ng-template #statusTemplate let-row>
    <p-tag 
      [value]="getStatusLabel(row.ticketStatus)"
      [severity]="getStatusSeverity(row.ticketStatus)">
    </p-tag>
  </ng-template>
  
  <ng-template #actionsTemplate let-row>
    <div class="actions-cell" style="display: flex; gap: 0.5rem; align-items: center;">
      <button
        pButton
        type="button"
        icon="pi pi-comments"
        class="p-button-text p-button-sm"
        (click)="goToChat(row); $event.stopPropagation()"
        [title]="'View Chat' | translate">
      </button>
      <!-- Temporarily hidden
      <button
        *ngIf="row.ticketStatus === 1"
        pButton
        type="button"
        icon="pi pi-ellipsis-v"
        class="p-button-text p-button-sm"
        (click)="toggleActionMenu($event, actionMenu, row)"
        [title]="'Actions' | translate">
      </button>
      <p-menu
        #actionMenu
        [model]="getActionMenuItems(row)"
        [popup]="true"
        appendTo="body">
      </p-menu>
      -->
    </div>
  </ng-template>

  <!-- Close Ticket Confirmation Modal -->
  <app-confirmation-modal
    [(visible)]="showCloseTicketModal"
    [title]="'Close Ticket' | translate"
    [message]="'Are you sure you want to close this ticket?' | translate"
    [confirmLabel]="'Yes' | translate"
    [cancelLabel]="'Cancel' | translate"
    confirmButtonClass="p-button-success"
    (confirm)="onConfirmStatusChange()"
    (cancel)="onCancelStatusChange()">
  </app-confirmation-modal>

  <!-- Reject Ticket Confirmation Modal -->
  <app-confirmation-modal
    [(visible)]="showRejectTicketModal"
    [title]="'Reject Ticket' | translate"
    [message]="'Are you sure you want to reject this ticket?' | translate"
    [confirmLabel]="'Yes' | translate"
    [cancelLabel]="'Cancel' | translate"
    confirmButtonClass="p-button-danger"
    (confirm)="onConfirmStatusChange()"
    (cancel)="onCancelStatusChange()">
  </app-confirmation-modal>

</app-list-table-filters-wrapper>
